import { Component, EventEmitter, OnDestroy, OnInit, Output, Input } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms'; // FormControl removed (unused)
import { ApiService } from '../../services';
import { combineLatest, of, Subject } from 'rxjs';
import { switchMap, take, takeUntil } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { ManagedUser, USER_ROLE } from '@pos-app/data'; // ORDER_TYPE_CONSTANT removed (unused)
import { getUserId, getUserRole } from '../../+state/core-ui/core-ui.selectors';
import { Store } from '@ngrx/store';
import { CoreUiPartialState } from '../../+state/core-ui/core-ui.reducer';

@Component({
    selector: 'app-lib-customer-printer-selector',
    templateUrl: './customer-printer-selector.component.html',
    styleUrls: ['./customer-printer-selector.component.scss'],
    standalone: false
})
export class CustomerPrinterSelector implements OnInit, OnDestroy {
  // Inputs
  @Input() printerList: any[]; // List of available printers
  @Input() orderNumber: number; // Order number
  @Input() orderClass: string; // Order class

  // Outputs
  @Output() selectPrinter = new EventEmitter<string>(); // Emits selected printer
  @Output() closeActiveModal = new EventEmitter(); // Emits when modal is closed

  // Form and state
  selectedPrinter: string; // Currently selected printer
  formValid: boolean; // Is form valid
  printerSelectorForm: UntypedFormGroup; // Form group for printer selection
  loading: boolean = false; // Loading state
  userRole: string; // Current user's role
  userDetails: ManagedUser; // Current user's details

  // RxJS subject for unsubscribing
  unSubscribe$ = new Subject<void>();

  constructor(
    private apiService: ApiService,
    private coreUIStore: Store<CoreUiPartialState>,
    private fb: UntypedFormBuilder,
  ) {}

  /**
   * Initialize component, setup form and fetch user details
   */
  ngOnInit(): void {
    // Initialize form group
    this.printerSelectorForm = this.fb.group({
      selectedPrinter: [''],
    });

    // Ensure printerList is always an array
    this.printerList = this.printerList || [];

    // Fetch user details based on role
    combineLatest([this.coreUIStore.select(getUserId), this.coreUIStore.select(getUserRole)])
      .pipe(
        take(1),
        switchMap(([userId, userRole]: [string, string]) => {
          this.userRole = userRole;

          // Internal users fetch JDE details, external users use email
          if (userRole !== USER_ROLE.external && userRole !== USER_ROLE.programme && userRole !== USER_ROLE.showExternal) {
            return this.apiService.fetchSingleJDE({
              userFilter: userId,
              fetchRegistered: 'Y',
            });
          }
        }),
        takeUntil(this.unSubscribe$),
      )
      .subscribe((res: any) => {
        this.userDetails = res.SearchResults[0];
        // Set printer if available
        if (this.userDetails?.printer) {
          this.printerSelectorForm.get('selectedPrinter').setValue(this.userDetails.printer);
        }
      });

    // Listen for form changes
    this.printerSelectorForm.valueChanges.subscribe((val: { selectedPrinter: string }) => {
      this.handleSelectedPrinter(val.selectedPrinter);
    });
  }

  /**
   * Handle printer selection change
   * @param printer Selected printer
   */
  handleSelectedPrinter(printer: string): void {
    this.selectedPrinter = printer;
    this.formValid = !!this.selectedPrinter;
  }

  /**
   * Cleanup subscriptions on destroy
   */
  ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }

  /**
   * Emit event to close modal
   */
  handleCloseModel(): void {
    this.closeActiveModal.emit();
  }

  /**
   * Emit selected printer
   */
  updatePrinter(): void {
    this.selectPrinter.emit(this.selectedPrinter);
  }
}

